export default __webpack_public_path__ + "static/media/fabula_mob_banner_3.41ed4040.png";